module.exports = __webpack_public_path__ + "static/media/managecomplaintB.c7bfcd4e.svg";